import { render } from "./HistoriaClinica.vue?vue&type=template&id=63b02bde"
import script from "./HistoriaClinica.vue?vue&type=script&lang=js"
export * from "./HistoriaClinica.vue?vue&type=script&lang=js"

import "./HistoriaClinica.vue?vue&type=style&index=0&id=63b02bde&lang=css"
import "./HistoriaClinica.vue?vue&type=style&index=1&id=63b02bde&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__